module.exports = __webpack_public_path__ + "static/media/quero-quero.3472c196.jpeg";